
import {
    defineComponent,
    inject,
    reactive,
    ref
} from "vue";

import type {
    FormInstance,
    FormRules
} from "element-plus";

//Services
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Auth from "@/core/services/AuthService"
import { errManager } from "@/core/config/Tools";

export default defineComponent({
    name: "dialog-password-reset",
    setup() {
        const submitButton = ref < HTMLButtonElement | null > (null);
        const open_modal_passreset = ref(inject('open_modal_passreset'))
        const ruleFormRef = ref < FormInstance > ()
        const form = reactive({
            username: '',
            email: '',
        })

        const rules = reactive < FormRules > ({
            username: [{
                required: true,
                message: "campo requerido",
                trigger: ["blur", "change"],
            }, ],
            email: [{
                    required: true,
                    message: 'campo requerido',
                    trigger: 'blur',
                },
                {
                    type: 'email',
                    message: 'Ingrese un correo válido',
                    trigger: ['blur', 'change'],
                },
            ]
        })

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;

            await formEl.validate((valid, fields) => {
                if (valid) onSubmitForgotPassword();
            });
        }

        //Form submit function
        const onSubmitForgotPassword = async () => {
            submitButton.value!.disabled = true;
            submitButton.value ?.setAttribute("data-kt-indicator", "on");
            await Auth.forgotPassword(form)
            .then( (res) => {
                submitButton.value ?.removeAttribute("data-kt-indicator");
                submitButton.value!.disabled = false;
                Swal.fire({
                    text: res.data.message,
                    icon: res.data.status,
                    buttonsStyling: false,
                    confirmButtonText: "Entendido!",
                    customClass: {
                        confirmButton: "btn fw-bold btn-light-" + (res.data.status == 'success' ? 'primary' : 'danger'),
                    },
                }).then(function () {
                    if(res.data.status == 'success')
                        open_modal_passreset.value = false
                });
            }).catch ( ({ response }) => {
                submitButton.value ?.removeAttribute("data-kt-indicator");
                submitButton.value!.disabled = false;
                errManager(response);
            })
        };

        const resetForm = (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            formEl.resetFields();
            submitButton.value ?.removeAttribute("data-kt-indicator");
            submitButton.value!.disabled = false;
        };

        return {
            open_modal_passreset,
            ruleFormRef,
            form,
            rules,
            submitButton,
            submitForm,
            onSubmitForgotPassword,
            resetForm
        };
    },
});
